import React from "react";
import {Grid} from "@material-ui/core";

export default ({classes, leftColContent, centralColContent}) =>
    <React.Fragment>
        <Grid item xs={12} md={3} className={classes.leftColumn}>{leftColContent}</Grid>
        <Grid item xs={12} md className={classes.centralColumn}>{centralColContent}</Grid>
    </React.Fragment>